import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ARTIST_NAME } from "@/data/content";

const EASE = [0.22, 1, 0.36, 1];

export const IntroLoader = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("vv_intro")) return;
    setShow(true);
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem("vv_intro", "1");
      setShow(false);
      document.body.style.overflow = "";
    }, 2100);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-loader"
          className="fixed inset-0 z-[110] flex flex-col items-center justify-center bg-[#0B0B0C]"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 0.85, ease: EASE }}
        >
          <div className="overflow-hidden">
            <motion.p
              initial={{ y: "112%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: 0.15, ease: EASE }}
              className="font-serif text-4xl font-light tracking-[0.14em] text-[#F9F8F6] sm:text-6xl"
            >
              {ARTIST_NAME}
            </motion.p>
          </div>
          <motion.span
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.9, delay: 0.65, ease: EASE }}
            className="mt-7 block h-px w-28 bg-[#C5A059]"
          />
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.95, ease: EASE }}
            className="mt-5 font-mono text-[10px] uppercase tracking-[0.55em] text-[#71717A]"
          >
            Saxophone · Live · Music
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
